<template>
  <v-radio-group
    :id="`rbg_${question.id}`"
    :name="`rbg_name_${question.id}`"
    v-model="question.selectedAnswer"
  >
    <!-- {{ question }} -->
    <v-list-item
      v-for="(option, i) in question.options"
      :key="`list_${option}_${i}`"
      class="group-item-list"
      @click="onItemClick(option, question)"
      :value="option.value"
      :disabled="isReadOnly"
      dense
    >
      <v-list-item-content class="font-weight-medium">
        <v-layout>
          <v-row align="center">
            <v-col cols="1">
              <v-row no-gutters justify="start">
                <v-radio
                  :id="`r_${option}_${i}`"
                  :value="option.value"
                  :name="`rb_${question.id}`"
                  dense
                  class="pa-0 ma-0 pl-2"
                  :readonly="isReadOnly"
                  @click.stop="onItemClick(option, question)"
                ></v-radio>
              </v-row>
            </v-col>
            <v-col cols="8" class="px-0">
              <v-row no-gutters justify="start"
                ><span class="expire-label" style="overflow-wrap: anywhere"
                  >{{ option.text }}
                </span></v-row
              >
            </v-col>
          </v-row>
        </v-layout>
      </v-list-item-content>
    </v-list-item>
  </v-radio-group>
</template>

<script>
export default {
  name: "RadioButtonChoice",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    value: {
      type: [Number, String, Array, Object],
    },
    isReadOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedItem: null,
      ex7: "red",
      ex8: "primary",
      items: [
        {
          label:
            "2222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222",
          value: "222",
        },
        {
          label: "33",
          value: "333",
        },
        {
          label: "4444",
          value: "4444",
        },
        {
          label: "5555",
          value: "5555",
        },
      ],
    };
  },
  computed: {
    answer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onItemClick,
  },
};

function onItemClick(item, question) {
  // item.voteCount++;
  this.selectedItem = item;
  //   question.selectedAnswer = item;
  // item.isSelected = !item.isSelected;
  // this.$emit("update: answer", this.selectedItem);
  // this.$emit("update", this.selectedItem);
}
</script>

<style scoped >
.border {
  border: 1px solid gray;
}
.group-item-list {
  margin-top: 2px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
.expire-label {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.vote-label {
  font-size: 0.688rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: darkblue;
}
.v-list-item-group .v-list-item--active {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}
</style>